import { render, staticRenderFns } from "./IntegrationInter.vue?vue&type=template&id=0a939552&scoped=true&"
import script from "./IntegrationInter.vue?vue&type=script&lang=js&"
export * from "./IntegrationInter.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationInter.vue?vue&type=style&index=0&id=0a939552&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a939552",
  null
  
)

export default component.exports